import { render, staticRenderFns } from "./SimServer.vue?vue&type=template&id=be1f83d2&scoped=true&"
import script from "./SimServer.vue?vue&type=script&lang=js&"
export * from "./SimServer.vue?vue&type=script&lang=js&"
import style0 from "./SimServer.vue?vue&type=style&index=0&id=be1f83d2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be1f83d2",
  null
  
)

export default component.exports